<template>
    <div>
        <pulse-loader :loading="loading"></pulse-loader>
        <div v-if="!loading">
            <div v-if="configurations.length == 0">
                Non hai nessuna configurazione salvata.
            </div>
            <div v-if="configurations.length > 0">
                <h1 class="mb-4">Configurazioni salvate</h1>
                <div class="row" v-if="!loading">
                    <div v-for="configuration of configurations" v-bind:key="configuration.id" class="col-lg-3 col-md-4 col-sm-6 col-12">
                        <catalog-model-card :model="configuration.model" :price="configuration.total_price" @click="onConfigurationSelect(configuration)"></catalog-model-card>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ConfigurationMixin from '../mixins/Configuration';
    import CatalogModelCard from './CatalogModelCard';

    export default {
        mixins: [ConfigurationMixin],
        components: { CatalogModelCard },
        mounted() {
            this.getConfigurations().then((resp) => {
                this.configurations = resp.data.data;
                this.loading = false;
            }).catch((error) => {
                console.error(error);
            });
        },
        data: function() {
            return {
                loading: true,
                configurations: null
            }
        },

        methods: {
            onConfigurationSelect(configuration) {
                this.$router.push({ name: 'configuration', params: { id: configuration.id } });
            }
        }
    }
</script>
